const TOOLS = {
  PENCIL: 'PENCIL',
  ERASER: 'ERASER',
  LINE: 'LINE',
  RECT: 'RECT',
  CIRCLE: 'CIRCLE',
  PALETTE: 'PALETTE',
  TEXT: 'TEXT',
  HAND: 'HAND',
  SELECT: 'SELECT',
  IMAGE: 'IMAGE',
  PATH: 'PATH',
  MATH: 'MATH'
}

const FILE_TYPES = {
  PDF: ['application/pdf'],
  IMAGES: ['image/jpeg', 'image/jpg', 'image/png']
}

const CONFIG = {
  zoom: 1,
  viewportTransform: [1, 0, 0, 1, 0, 0],
  lastPosX: 0,
  lastPosY: 0
}

const MEDIA_SCALE_HEIGHT = 640

const COLOR_PALETTE = [
  '(255,255,255)',
  '(215,100,185)',
  '(120,159,230)',
  '(249,185,88)',
  '(135,191,79)',
  '(243,100,117)'
]

export default {
  TOOLS,
  CONFIG,
  COLOR_PALETTE,
  MEDIA_SCALE_HEIGHT,
  FILE_TYPES
}
